import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class ContactUsService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    getallcontactus(): Promise<any> {
        return this.httpmanagerService.HttpGet('contactus/getall', "").then(function (data) {
            return data.data
        })
    }
    ddata(id): Promise<any> {
        return this.httpmanagerService.HttpDelete('contactus/delete' + id, "").then(function (data) {
            return data
        })
    }
    contactanswer(id, data): Promise<any> {
        return this.httpmanagerService.HttpPut('contactus/answerby', JSON.stringify(data), id).then(data => {
            return data;
        });
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/contactus/contactus.service.ts